export function isHexColor(color: string): boolean {
    const HEX_REGEX = /^#([0-9A-F]{3}){1,2}$/i

    return HEX_REGEX.test(color.trim())
}

export function isRGBColor(color: string): boolean {
    const RGB_REGEX = /rgb\((\d{1,3}), (\d{1,3}), (\d{1,3})\)/

    return RGB_REGEX.test(color.trim())
}

export default function isValidColor(color: string): boolean {
    return isHexColor(color) || isRGBColor(color)
}
